module.exports = __webpack_public_path__ + "img/Bodice-Front-B7-Gd-Da-Ea.5029c9e5.png";